export class Base {
    public CONTESTANT_STATE_NOT_SIGNED_UP = "not_signed_up";
    public CONTESTANT_STATE_SIGN_UP_PENDING = "sign_up_pending";
    public CONTESTANT_STATE_SIGNED_UP = "signed_up";
    public CONTESTANT_STATE_CHECKED_IN = "checked_in";
    public CONTESTANT_STATE_PLAYING = "playing";
    public CONTESTANT_STATE_FINISHED = "finished";
    public CONTESTANT_STATE_MISC;

    public STATE_LEVEL_BASE = 0;
    public STATE_LEVEL_PRE_SIGN_UP = 1;
    public STATE_LEVEL_SIGN_UP = 2;
    public STATE_LEVEL_CHECK_IN = 3;
    public STATE_LEVEL_LATE_SIGN_UP = 4;
    public STATE_LEVEL_POST_SIGN_UP = 5;
    public STATE_LEVEL_IN_PROGRESS = 6;
    public STATE_LEVEL_FINISHED = 7;
    public STATE_LEVEL = 0;

    constructor(public contestantState?: any) {}

    public getActiveTitle(): string {
        switch (this.contestantState) {
            case this.CONTESTANT_STATE_NOT_SIGNED_UP: {
                return "signup";
            }
            case this.CONTESTANT_STATE_SIGNED_UP: {
                return "checkin";
            }
            case this.CONTESTANT_STATE_CHECKED_IN: {
                return "play";
            }
            case this.CONTESTANT_STATE_PLAYING: {
                return "play";
            }
        }
    }

    public showSignedUpTitle() {
        return false;
    }

    public isSignUpEnabled() {
        return false;
    }

    public getNotSignedUpTemplates() {
        return [];
    }

    public getSignedUpTemplates() {
        return [];
    }

    public getSignUpPendingTemplates() {
        return ["Information"];
    }

    public getCheckedInTemplates() {
        return [];
    }

    public getPlayingTemplates() {
        return [];
    }

    public getFinishedTemplates() {
        return [];
    }

    public getMiscTemplates() {
        return [];
    }

    public getContentTemplates() {
        switch (this.contestantState) {
            case this.CONTESTANT_STATE_NOT_SIGNED_UP: {
                return this.getNotSignedUpTemplates();
            }
            case this.CONTESTANT_STATE_SIGN_UP_PENDING: {
                return this.getSignUpPendingTemplates();
            }
            case this.CONTESTANT_STATE_SIGNED_UP: {
                return this.getSignedUpTemplates();
            }
            case this.CONTESTANT_STATE_CHECKED_IN: {
                return this.getCheckedInTemplates();
            }
            case this.CONTESTANT_STATE_PLAYING: {
                return this.getPlayingTemplates();
            }
            case this.CONTESTANT_STATE_FINISHED: {
                return this.getFinishedTemplates();
            }
        }
    }
}
